import { Jiffy } from "@green24/npm-javascript-utils";
import { TariffUtils } from "../utils/Class/TariffUtils";

export const DEFAULT_GOOGLE_API_KEY = "AIzaSyDaKopefBL1yaqB-md2JkjF8MYepSzKZko";
export const GOOGLE_MAPS_DEFAULT_POSITION = [50.06, 14.4];

export const TRY_DEMO_PARTNER_QUERY_KEY = "tryPartner";

/**
 * @type {RegExp}
 * @see https://www.w3resource.com/javascript/form/email-validation.php
 */
export const EMAIL_REGEX = /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/;

/**
 * Prompt dialog action button model
 * ---
 * @type {{
 *  returnValue: any,
 *  icon: string,
 *  action: function(returnValue),
 *  style: string,
 *  disabled: boolean,
 *  text: string,
 *  class: string,
 * }}
 */
export const model_promptDialog_actionButton = {
	icon: null,
	text: null,
	action: null,
	returnValue: null,
	class: null,
	style: null,
	disabled: false,
};

/**
 * Prompt dialog configuration model
 * ----
 * @type {{
 *  icon: string,
 *  actionButtons: [model_promptDialog_actionButton],
 *  theme: null|"error",
 *  title: string,
 *  message: string,
 *  entity: string,
 *  cancelButton?: model_promptDialog_actionButton,
 *  confirmButton?: model_promptDialog_actionButton,
 *  closeButton?: model_promptDialog_actionButton,
 * }}
 */
export const model_promptDialog_configuration = {
	icon: null,
	title: null,
	message: null,
	entity: null,
	actionButtons: [],
	theme: null,
};

/**
 * Language model
 * ---
 * @type {{
 * 	id?: number,
 *	createdOn?: Date,
 *	languageCode?: string,
 *	displayName?: string,
 * }}
 */
export const model__language = {
	id: undefined,
	createdOn: undefined,
	languageCode: '',
	displayName: '',
};

/**
 * Display Text model
 * ---
 * @type {{
 * 	id?: number,
 *	createdOn?: Date,
 *	language?: model__language,
 *	text?: string,
 * }}
 */
export const model__displayText = {
	id: undefined,
	createdOn: undefined,
	language: model__language,
	text: '',
};

/**
 * Currency enum
 * ---
 * Default currency only, all currencies are fetched from the backend...
 * @enum string
 * @readonly
 */
export const E_Currency = {
	CZK: "CZK"
}

/**
 * Cost model
 * @type {{
 *  withoutTax: number,
 *  withTax: number,
 * }}
 */
export const model__cost = {
	withoutTax: 0,
	withTax: 0,
};

/**
 * Partner name model
 * ---
 * @type {{
 * 	id?: number,
 *	name?: string,
 * }}
 */
export const model__partnerName = {
	id: undefined,
	name: '',
};

/**
 * Partner Nested model
 * ---
 * @type {{
 * 	id?: number,
 *	createdOn?: Date,
 *	name?: string,
 * }}
 */
export const model__partnerNested = {
	id: undefined,
	createdOn: undefined,
	name: '',
};

/**
 * Session type enum
 * ---
 * @enum string
 * @readonly
 */
export const E_SessionType = {
	EXTERNAL: "EXTERNAL",
	PUBLIC_REGISTERED: "PUBLIC_REGISTERED",
	PUBLIC_ONE_TIME: "PUBLIC_ONE_TIME",
	INTERNAL: "INTERNAL",
	TEST: "TEST",
	OTHER: "OTHER",
	RESERVATION: "RESERVATION",
	HUBJECT: "HUBJECT",
	OCPI: "OCPI",
};
/**
 * Session charging state enum - mirrors ChargingStateType in the core backend
 */
export const E_ChargingState = {
	CHARGING: "CHARGING",
	STOPPED: "STOPPED",
	STARTING: "STARTING",
	STOPPING: "STOPPING",
	WAITING_FOR_CABLE_REMOVAL: "WAITING_FOR_CABLE_REMOVAL",
	PARKING: "PARKING",
	ERROR: "ERROR",
	RESERVED: "RESERVED",
	WAITING_FOR_AMENITY: "WAITING_FOR_AMENITY",
	SCHEDULED: "SCHEDULED",
};
/**
 * Session graph type enum
 * ---
 * @enum string
 * @readonly
 */
export const E_SessionGraphType = {
	POWER_KWH: "POWER_KWH",
	AMPERAGE: "AMPERAGE",
	VOLTAGE: "VOLTAGE",
};

/**
 * Currency model
 * ---
 * @type {{
 *  displayName: string,
 *  currency: E_Currency,
 * }}
 */
export const model__currency = {
	currency: E_Currency.CZK,
	displayName: 'Kč',
}

export const model_notification = {
	content: [],
	dismissType: "DISMISSABLE",	// ONE_SHOT, DISMISSABLE, PERMANENT
	targets: ["IOS", "ANDROID", "WEB"],	// IOS, ANDROID, WEB
	title: [],
	validUntil: "",
	visible: false,
};

export const model_address = {
	"city": "",
	"country": "",
	"email": "",
	"floor": "",
	"houseNumber": "",
	"latitude": 0,
	"longitude": 0,
	"phoneNumber": "",
	"postalCode": "",
	"street": "",
	"url": ""
};

/**
 * Bank account details model
 * ---
 * @type {{
 *  iban: string,
 *  bankName: string,
 *  accountNumber: string,
 *  swift: string,
 * }}
 */
export const model__bankAccountDetails = {
	bankName: null,
	accountNumber: null,
	swift: null,
	iban: null,
};

/**
 * Opening hours opening type enum
 * ---
 * @enum string
 * @readonly
 */
export const E_Location_OpeningHours_OpeningType = {
	NONSTOP: "NONSTOP",
	SPECIFIC: "SPECIFIC",
	CLOSED: "CLOSED",
};

/**
 * Opening hours period
 * ---
 * @type {{
 *  id: number,
 *  createdOn: Date,
 *  fromTime: string,
 *  toTime: string,
 * }}
 */
export const model__openingHoursPeriod = {
	id: undefined,
	createdOn: undefined,
	fromTime: "00:00",
	toTime: "00:00",
};

/**
 * Opening hours entry model
 * ---
 * @type {{
 *  id: number,
 *  createdOn: Date,
 *  weekday: Jiffy.enum.weekday,
 *  openingType: string,
 *  periods: model__openingHoursPeriod[],
 * }}
 */
export const model__openingHoursEntry = {
	id: undefined,
	createdOn: undefined,
	weekday: Jiffy.enum.weekday.MONDAY,
	openingType: E_Location_OpeningHours_OpeningType.NONSTOP,
	periods: [],
};

/**
 * Opening hours model
 * ---
 * @type {{
 *  id: number,
 *  createdOn: Date,
 *  entries: model__openingHoursEntry[],
 *  stopChargingAfterHoursGracePeriodMinutes: number,
 *  timezone: string,
 *  stopChargingAfterHours: boolean,
 *  twentyFourSeven: boolean,
 *  allowChargingAfterHours: boolean,
 * }}
 */
export const model__openingHours = {
	id: undefined,
	createdOn: undefined,
	timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
	twentyFourSeven: true,
	allowChargingAfterHours: false,
	stopChargingAfterHours: false,
	stopChargingAfterHoursGracePeriodMinutes: 15,
	entries: [],
};

export const E_BadgeMode = {
	DISABLED: "DISABLED",
	OPTIONAL: "OPTIONAL",
	REQUIRED: "REQUIRED"
}


/**
 * Location availability enum
 * ---
 * @enum string
 * @readonly
 */
export const E_Location_Availability = {
	AVAILABLE: "AVAILABLE",
	NOT_AVAILABLE: "NOT_AVAILABLE",
};

/**
 * Location availability state enum
 * ---
 * @enum string
 * @readonly
 */
export const E_Location_AvailabilityState = {
	AVAILABLE: "AVAILABLE",
	AVAILABLE_UNCERTAIN: "AVAILABLE_UNCERTAIN",
	NOT_AVAILABLE_OUT_OF_ORDER: "NOT_AVAILABLE_OUT_OF_ORDER",
	NOT_AVAILABLE_OCCUPIED: "NOT_AVAILABLE_OCCUPIED",
	NOT_AVAILABLE_OFF_HOURS: "NOT_AVAILABLE_OFF_HOURS",
	NOT_AVAILABLE_MANUALLY_DISABLED: "NOT_AVAILABLE_MANUALLY_DISABLED",
};


/**
 * Location visibility enum
 * ---
 * @enum string
 * @readonly
 */
export const E_Location_Visibility = {
	VISIBLE: "VISIBLE",
	HIDDEN_TO_PUBLIC: "HIDDEN_TO_PUBLIC",
	HIDDEN_TO_DRIVERS: "HIDDEN_TO_DRIVERS",
	HIDDEN_TO_PARTNERS: "HIDDEN_TO_PARTNERS",
};

/**
 * View of the EVSEs on a location detail (frontend only)
 * ---
 * @enum string
 * @readonly
 */
export const E_LocationType = {
	ON_STREET: "ON_STREET",
	PARKING_GARAGE: "PARKING_GARAGE",
	UNDERGROUND_GARAGE: "UNDERGROUND_GARAGE",
	PARKING_LOT: "PARKING_LOT",
	ON_DRIVEWAY: "ON_DRIVEWAY",
	ALONG_MOTORWAY: "ALONG_MOTORWAY",
	OTHER: "OTHER",
	UNKNOWN: "UNKNOWN",
};

export const E_LocationEvsesView = {
	CARDS: "CARDS",
	TABLE: "TABLE",
	LAYOUT: "LAYOUT",
};

export const model_location = {
	address: model_address,
	applicationType: "DEFAULT",
	availability: E_Location_Availability.AVAILABLE,
	availabilityState: E_Location_AvailabilityState.AVAILABLE,
	currentInfo: [],
	description: [],
	developerDescription: "",
	evses: [],
	externalInfo: null,
	facilities: [],
	images: [],
	instructions: [],
	lifecycleStage: "PROPOSED",
	locationType: "ON_STREET",
	maintenanceEntries: [],
	markerType: "POLYFAZER_STANDARD",
	name: "",
	openingHours: model__openingHours,
	parkingSystemConfiguration: null,
	partner: null,
	polyfazerEnabled: true,
	region: null,
	subtitles: [],
	visibility: E_Location_Visibility.HIDDEN_TO_DRIVERS,
	disableNotifications: false,
	excludeFromDashboardTracking: false,
	badgeMode: E_BadgeMode.DISABLED
};

/**
 * Connection health model
 * ---
 * @type {{
 *  pingEnabled: boolean,
 *  closeDead: boolean,
 *  pingIntervalSeconds: number,
 *  deadAfterSeconds: number,
 * }}
 */
export const model__connectionHealth = {
	pingEnabled: false,
	closeDead: false,
	pingIntervalSeconds: 30,
	deadAfterSeconds: 90,
};

export const model__unitConfiguration = {
	targetPower: 22,
	bootNotificationStopsCharging: false,
	chargePointIdentity: undefined,
	cypherKey: "00112233445566778899AABBCCDDEEFF",
	declineZeroStartMeterTransactions: false,
	feedbackEnabled: false,
	getStateIntervalWhenCharging: 0,
	getStateIntervalWhenIdle: 0,
	getStateScriptUrl: null,
	gsmPassword: "123456",
	heartBeatIntervalSeconds: 120,
	ipAddress: null,
	lightingEnabled: false,
	maxPlausiblePowerKw: null,
	meterValuesSampleIntervalSeconds: 30,
	port: null,
	returnAddressOverride: null,
	startScriptUrl: null,
	stopScriptUrl: null,
	supportExternalCharging: false,
	supportParking: false,
	numberOfChannel: 2,
	timeoutConfiguration: {
		communicationLossWhenCharging: 240,
		communicationLossWhenIdle: 600,
		ignoreStopAfterStart: 10,
		inactivityAfterStart: 60,
		meterInactivity: null,
	},
	connectionHealth: model__connectionHealth,
};

export const model__evseWizardConfiguration = {
	deviceTemplate: null,
	unitConfiguration: model__unitConfiguration,
	tariff: null,
};

export const model_externalLocation = {
	address: model_address,
	connectors: [],
	descriptions: [],
	developerDescription: null,
	images: [],
	name: null,
	provider: null,
	providerDisplayName: null,
	region: null,
	visibility: "VISIBLE"
};

export const model_externalLocationConnector = {
	numberOfConnectors: 1,
	amperage: 32,
	voltage: 400,
	powerOutput: 22,
	powerType: "AC_3_PHASE",
	standard: {},
};

export const model__connectorConfiguration = {
	voltage: 400,
	amperage: 32,
	format: "CABLE",	// SOCKET, CABLE, OUTLET
	meterValueMultiplier: 1,
	powerOutput: 22,
	connectorID: 1, // channel
	powerType: "AC_3_PHASE",	// AC_1_PHASE, AC_3_PHASE, DC
	standard: {},
};

export const model_connector = {
	availability: "AVAILABLE",
	visibility: "VISIBLE",
	chargingPassword: null,
	connectorConfiguration: model__connectorConfiguration,
	customerTariff: null,
	displayLetter: null,
	roamingConfiguration: {
		hubject: {},
		sygic: {},
		ocpi: {},
		embeddedApps: {},
		partnerSharing: {
			partners: [],
		},
	},
	amenities: [],
	userRestrictions: [],
};

export const model_evse = {
	availability: "AVAILABLE",
	group: null,
	physicalReference: {
		id: null,
		available: true,
		description: null,
		identifierValue: null,
	},
	visibility: "VISIBLE", // HIDDEN_TO_DRIVERS, HIDDEN_TO_PARTNER
	device: {},
};

export const model_evseIdentifier = {
	identifierValue: null,
	description: null
};

export const E_Unit_Visibility = {
	VISIBLE: "VISIBLE",
	HIDDEN_TO_PARTNERS: "HIDDEN_TO_PARTNERS",
};

export const E_Unit_Type_Family = {
	LEVEL: "LEVEL",
	OCPP15: "OCPP15",
	OCPP16: "OCPP16",
	OCPP20: "OCPP20",
	KEBA_UDP: "KEBA_UDP",
	QUIDO: "QUIDO",
	EXTERNAL_HTTP: "EXTERNAL_HTTP",
	VIRTUAL: "VIRTUAL",
	MOLARIS: "MOLARIS",
	LAN_CONTROLLER: "LAN_CONTROLLER",
	NIKOLA_MODBUS: "NIKOLA_MODBUS",
	LANCELOT: "LANCELOT",
	ENSTO: "ENSTO",
	GOE: "GOE",
	OCPI: "OCPI"
}

export const model_unit = {
	visibility: E_Unit_Visibility.VISIBLE,
	available: true,
	development: false,
	description: null,
	unitConfiguration: model__unitConfiguration,
	unitType: {
		family: null,
	},
	manufacturerInfo: {
		chargePointModel: null,
		chargePointSerialNumber: null,
		chargePointVendor: null,
		firmwareVersion: null,
		manufacturerName: null,
		manufacturerUnitDesignation: null
	},
	device: {},
};

/**
 * Tariff component type enum
 * ---
 * @enum string
 * @readonly
 */
export const E_TariffComponentType = {
	FLAT: "FLAT",
	TIME_MINUTE: "TIME_MINUTE",
	TIME_KWH_BRACKETS: "TIME_KWH_BRACKETS",
	MINIMUM_PRICE: "MINIMUM_PRICE",
	KWH: "KWH",
	FORMULA: "FORMULA",//Internal only
	PARKING_TIME_MINUTE: "PARKING_TIME_MINUTE",
	RESERVATION_MINUTE: "RESERVATION_MINUTE",
	OCCUPATION_MINUTE: "OCCUPATION_MINUTE",
	DISCOUNT: "DISCOUNT",
	ENERGY_ECO_TAX: "ENERGY_ECO_TAX",
};

/**
 * Tariff kW bracket model
 * ---
 * @type {{
 * 	id?: number,
 * 	createdOn?: Date,
 * 	kwLimitValue?: number,
 * 	price?: number
 * }}
 */
export const model__tariffKwBracket = {
	id: undefined,
	createdOn: undefined,
	kwLimitValue: 0,
	price: 0,
};

/**
 * Tariff component model
 * ---
 * @type {{
 * 	id: number,
 * 	createdOn: Date,
 * 	type: E_TariffComponentType,
 * 	price: number,
 * 	taxPercent: number,
 * 	unit: number,
 * 	freeUnits: number,
 * 	formula: string,
 * 	applyWhenZeroKwh: boolean,
 * 	kwBrackets: model__tariffKwBracket[]
 * }}
 */
export const model_tariffComponent = {
	createdOn: undefined,
	formula: null,
	freeUnits: null,
	id: undefined,
	kwBrackets: [],
	price: 0,
	type: E_TariffComponentType.KWH,
	unit: 1,
	taxPercent: 0,
	applyWhenZeroKwh: false,
};

/**
 * Tariff component set type enum
 * ---
 * @enum string
 * @readonly
 */
export const E_TariffComponentSetType = {
	POLYFAZER: "POLYFAZER",
	OCPI: "OCPI",
	HUBJECT: "HUBJECT",
	SYGIC: "SYGIC",
};

export const model__tariffComponentSetGeoLocationLimit = {
	latitude: null,
	longitude: null,
	radiusMeters: null,
	description: ""
};

/**
 * Tariff component set model
 * ---
 * @type {{
 * 	id: number,
 * 	createdOn: Date,
 * 	components: model_tariffComponent[],
 * 	membership: model_membership,
 * 	temporaryUserSet: boolean,
 * 	type: E_TariffComponentSetType,
 * 	geoLocationLimit: model__tariffComponentSetGeoLocationLimit,
 * }}
 */
export const model_tariffComponentSet = {
	id: undefined,
	type: null,
	membership: null,
	components: [],
	temporaryUserSet: false,
	geoLocationLimit: null,
};

/**
 *
 * @type {{
 *  successor: {exchangeAt: Date, tariff: model_tariff},
 *  partner: {id: number, name: string},
 *  name: string,
 *  taxPercent: number,
 *  description: string,
 *  currency: string,
 *  componentSets: [model_tariffComponentSet],
 *  region: {id: number, name: string}
 * }}
 */
export const model_tariff = {
	taxPercent: 0,
	currency: "CZK",
	componentSets: [
		TariffUtils.getNewComponentSetForEdit(E_TariffComponentSetType.POLYFAZER),
		TariffUtils.getNewComponentSetForEdit(E_TariffComponentSetType.HUBJECT),
		TariffUtils.getNewComponentSetForEdit(E_TariffComponentSetType.OCPI),
		TariffUtils.getNewComponentSetForEdit(E_TariffComponentSetType.SYGIC),
	],
	name: "",
	description: null,
	partner: null,
	region: null,
	successor: null,
};

/**
 * Coupon origin enum
 * ---
 * @enum string
 * @readonly
 */
export const E_Coupon_Origin = {
	PREMIUM_SMS: "PREMIUM_SMS",
	PAYMENT_TERMINAL: "PAYMENT_TERMINAL",
	GROUP_PAY: "GROUP_PAY",
	GROUP_PAY_DIRECT: "GROUP_PAY_DIRECT",
	OTHER: "OTHER",
};


/**
 * Coupon type enum
 * ---
 * @enum string
 * @readonly
 */
export const E_Coupon_Type = {
	ENERGY: "ENERGY",
	PRICE: "PRICE",
};

export const model_coupon = {
	origin: E_Coupon_Origin.OTHER,
	allowMultipleUses: false,
	couponNumber: null,
	couponRestrictions: null,
	currency: null,
	discountPercent: null,
	group: null,
	hiddenDescription: null,
	id: null,
	maxUsers: null,
	maxUsesPerUser: null,
	partner: null,
	publicDescription: null,
	region: null,
	type: E_Coupon_Type.ENERGY,
	usersLeft: null,
	validUntil: null,
	value: null,
};

export const model_sequence = {
	applicableToNonEntrepreneurs: true,
	name: "",
	numberDefinition: "",
	numberOfDigits: "",
	resetYearly: true,
	generateZeroInvoices: false,
	startingNumber: "",
	variableSymbolDefinition: "",
	variableSymbolDigits: "",
	region: {},
	partner: {},
	generatePremiumSMSInvoices: false,
};

/**
 * Business details model
 * ---
 * @type {{
 *  country: string,
 *  companyRegistrationNumber: string,
 *  city: string,
 *  contactEmail: string,
 *  companyName: string,
 *  postalCode: string,
 *  houseNumber: string,
 *  landLine: string,
 *  taxIDNumber: string,
 *  street: string,
 *  webUrl: string,
 *  logo: Object,
 *  floor: string,
 *  cellPhone: string
 * }}
 */
export const model__businessDetails = {
	companyName: null,
	taxIDNumber: null,
	companyRegistrationNumber: null,
	street: null,
	houseNumber: null,
	floor: null,
	postalCode: null,
	city: null,
	country: null,
	landLine: null,
	cellPhone: null,
	webUrl: null,
	contactEmail: null,
	logo: null,
};

/**
 * Payment order type enum
 * ---
 * @enum string
 * @readonly
 */
export const E_PaymentOrderType = {
	INVOICE_REQUEST: "INVOICE_REQUEST",
	PAYMENT_ORDER: "PAYMENT_ORDER",
	SELF_BILLING: "SELF_BILLING",
};

/**
 * Partner billing contract type enum
 * ---
 * @enum string
 * @readonly
 */
export const E_PartnerBillingContractType = {
	DEMO: "DEMO",
	FULL: "FULL",
	OTHER: "OTHER",
};

/**
 * Whose data is counted for the partner's tariff components. Null is treated as DEFAULT.
 */
export const E_PartnerBillingDataSourceMode = {
	DEFAULT: "DEFAULT",
	PARTNER_OVERRIDE: "PARTNER_OVERRIDE",
	REGION_OVERRIDE: "REGION_OVERRIDE",
};

/**
 * Partner billing configuration model
 * ---
 * @type {{
 *  contractEnd: string,
 *  orderSeriesDefinition: Object,
 *  contractNumber: string,
 *  feeTax: number,
 *  polyfazerInvoiceCurrency: E_Currency,
 *  businessDetails: Object,
 *  polyfazerInvoiceFeeTax: number,
 *  invoiceLocale: string,
 *  tariffComponents: Object[],
 *  invoiceEmails: string[],
 *  currency: E_Currency,
 *  contractStart: string,
 *  dueDays: number,
 *  polyfazerInvoiceDueDays: number,
 *  polyfazerInvoiceSubType: E_PaymentOrderType,
 *  polyfazerInvoiceSelfBillingSeries?: model_sequence,
 *  contractType: E_PartnerBillingContractType,
 *  dataSourceMode: E_PartnerBillingDataSourceMode,
 *  dataSourcePartner?: model__partnerName,
 *  dataSourceRegion?: Object,
 * }}
 */
export const model__partnerBillingConfiguration = {
	businessDetails: null,
	contractEnd: null,
	contractNumber: null,
	contractStart: null,
	currency: null,
	feeTax: null,
	invoiceEmails: [],
	invoiceLocale: null,
	orderSeriesDefinition: null,
	polyfazerInvoiceCurrency: null,
	polyfazerInvoiceFeeTax: null,
	tariffComponents: [],
	dueDays: 14,
	polyfazerInvoiceDueDays: 14,
	taxPayer: true,
	reverseChargeMode: false,
	polyfazerInvoiceSubType: E_PaymentOrderType.INVOICE_REQUEST,
	polyfazerInvoiceSelfBillingSeries: null,
	contractType: E_PartnerBillingContractType.FULL,
	dataSourceMode: E_PartnerBillingDataSourceMode.DEFAULT,
	dataSourcePartner: null,
	dataSourceRegion: null,
	sessionExportEnabled: false,
	sessionExportProfile: null,
	sessionExportFilters: null,
	sessionExportFilterConfiguration: null,
	sessionExportTimezone: null,
};

export const E_PartnerTariff_ComponentType = {
	FLAT: "FLAT",
	FLAT_PUBLIC_CONNECTORS: "FLAT_PUBLIC_CONNECTORS",
	FLAT_PRIVATE_CONNECTORS: "FLAT_PRIVATE_CONNECTORS",
	FLAT_PUBLIC_LOCATIONS: "FLAT_PUBLIC_LOCATIONS",
	FLAT_PRIVATE_LOCATIONS: "FLAT_PRIVATE_LOCATIONS",
	FLAT_IDENTIFIERS: "FLAT_IDENTIFIERS",
	SESSION_PRICE_PERCENT: "SESSION_PRICE_PERCENT",
	SESSION_MINIMUM_PER_KWH: "SESSION_MINIMUM_PER_KWH",
	SESSION_MINIMUM_PER_CONNECTOR: "SESSION_MINIMUM_PER_CONNECTOR",
	SESSION_MINIMUM_PER_LOCATION: "SESSION_MINIMUM_PER_LOCATION",
	SIM_CARD: "SIM_CARD",
	FLAT_SESSION_PRIVATE: "FLAT_SESSION_PRIVATE",
	FLAT_SESSION_PUBLIC: "FLAT_SESSION_PUBLIC",
};

/**
 * Payment gate enum
 * @enum string
 * @readonly
 */
export const E_PaymentGate = {
	CSOB_EAPI: "CSOB_EAPI",
	KH_API: "KH_API",
	SIMPLEPAY: "SIMPLEPAY",
};

/**
 * Invoice generation type enum
 * ---
 * Selects which system generates end-user invoices.
 * Configured on the region and optionally overridden per partner.
 * @enum string
 * @readonly
 */
export const E_InvoiceGenerationType = {
	DEFAULT: "DEFAULT",
	SMARTBILL: "SMARTBILL",
	BILLINGO: "BILLINGO",
};

/**
 * Invoice reporting type enum
 * ---
 * Selects whether and to which external system end-user invoices are reported.
 * Independent of the invoice generation type. Configured on the region and optionally overridden per partner.
 * @enum string
 * @readonly
 */
export const E_InvoiceReportingType = {
	DEFAULT: "DEFAULT",
	EINVOICE: "EINVOICE",
	EET: "EET",
};

/**
 * Billingo configuration model
 * ---
 * Credentials and references for the hungarian Billingo billing platform. Configured on the region
 * and optionally overridden per partner. Only relevant when invoiceGenerationType is BILLINGO.
 * @type {{
 *  apiKey: string,
 *  blockId: number,
 *  bankAccountId: number,
 * }}
 */
export const model__billingoSettings = {
	apiKey: null,
	blockId: null,
	bankAccountId: null,
};

/**
 * EET configuration model
 * ---
 * Identifiers for the czech EET sales registration. Configured on the region and optionally overridden per partner.
 * Only relevant when invoiceReportingType is EET. The certificate is uploaded separately and never returned,
 * only its holder and validity are (read only).
 * @type {{
 *  unitId: number,
 *  cashRegisterId: string,
 *  delegatingEic: string,
 *  certificateEic: string,
 *  certificateValidTo: string,
 * }}
 */
export const model__eetSettings = {
	unitId: null,
	cashRegisterId: null,
	delegatingEic: null,
	certificateEic: null,
	certificateValidTo: null,
};

export const model_region = {
	emailErrorSender: "",
	emailSender: "",
	name: "",
	premiumSmsConfiguration: null,
	partnerBillingDetails: {},
	bankAccountDetails: model__bankAccountDetails,
	roamingBankAccountDetails: {},
	defaultEndUserBillingDetails: {},
	partnerInvoiceCopyRecipients: [],
	partnerInvoiceCopyLocale: null,
	roamingPriceMultiplierHubject: null,
	roamingVatPercentage: null,
	generateRoamingInvoices: false,
	roamingOrderSeries: null,
	paymentGate: E_PaymentGate.CSOB_EAPI,
	paymentGateIdentifier: null,
	disableCreditPurchasePayments: true,
	invoiceGenerationType: E_InvoiceGenerationType.DEFAULT,
	invoiceReportingType: E_InvoiceReportingType.DEFAULT,
	billingoSettings: null,
	eetSettings: null,
};

/**
 * Partner model
 * ---
 * @type {{
 *  hiddenDescription: string,
 *  parasiteTariffs: model__parasiteTariff[],
 *  supportPhone: string,
 *  businessDetails: model__businessDetails,
 *  createdOn: Date,
 *  enabled: boolean,
 *  billingConfiguration: model__partnerBillingConfiguration,
 *  emailErrorSender: string,
 *  energyUnitName: string,
 *  supportEmail: string,
 *  bankAccountDetails: model__bankAccountDetails,
 *  useRegionBillingDetails: boolean,
 *  useRegionIssuerDetails: boolean,
 *  roamingPriceMultiplierHubject: number,
 *  name: string,
 *  orderSeries: model_sequence,
 *  logo: Object,
 *  contactAddress: model_address,
 *  id: number,
 *  region: model_region,
 *  emailSender: string,
 *  currencies: model__currency[],
 *  paymentGate: E_PaymentGate,
 *  paymentGateIdentifier: string,
 *  invoiceGenerationType: E_InvoiceGenerationType,
 *  invoiceReportingType: E_InvoiceReportingType,
 *  billingoSettings: model__billingoSettings,
 *  eetSettings: model__eetSettings,
 * }}
 */
export const model_partner = {
	enabled: true,
	id: undefined,
	createdOn: undefined,
	name: null,
	hiddenDescription: null,
	contactAddress: model_address,
	businessDetails: model__businessDetails,
	useRegionBillingDetails: false,
	useRegionIssuerDetails: false,
	region: null,
	billingConfiguration: model__partnerBillingConfiguration,
	orderSeries: null,
	bankAccountDetails: model__bankAccountDetails,
	energyUnitName: "kWh",
	emailSender: null,
	emailErrorSender: null,
	logo: null,
	currencies: [],
	parasiteTariffs: [],
	roamingPriceMultiplierHubject: 1,
	supportPhone: null,
	supportEmail: null,
	paymentGate: E_PaymentGate.CSOB_EAPI,
	paymentGateIdentifier: null,
	invoiceGenerationType: null,
	invoiceReportingType: null,
	billingoSettings: null,
	eetSettings: null,
};

export const E_ExternalLoginService = {
	GOOGLE: "GOOGLE",
	FACEBOOK: "FACEBOOK",
	APPLE: "APPLE",
	ENTRA: "ENTRA",
};

export const E_LoginMethod = {
	PASSWORD: "PASSWORD",
	...E_ExternalLoginService,
};

/**
 * User account state enum
 * ---
 * @enum string
 * @readonly
 */
export const E_UserAccountState = {
	ACTIVE: "ACTIVE",
	CHARGING_SUSPENDED: "CHARGING_SUSPENDED",
	DISABLED: "DISABLED",
};

/**
 * User account type enum
 * ---
 * @enum string
 * @readonly
 */
export const E_AccountType = {
	POLYFAZER: "POLYFAZER",
	OCPI: "OCPI",
	HUBJECT: "HUBJECT",
	SYGIC: "SYGIC",
};

/**
 * User Account Nested model
 * ---
 * @type {{
 * 	id?: number,
 *	email?: string,
 *	forename?: string,
 *	surname?: string,
 *	type?: E_AccountType,
 * }}
 */
export const model__userAccountNested = {
	id: undefined,
	email: '',
	forename: '',
	surname: '',
	type: E_AccountType.POLYFAZER,
};

/**
 * Badge Type model
 * ---
 * @type {{
 * 	id?: number,
 *	createdOn?: Date,
 *	name: string,
 *	description?: string,
 *	instructions?: model__displayText[],
 *	paymentSubstitute?: boolean,
 *	providesFreeCharging?: boolean,
 *	partner?: model__partnerNested,
 *	disableWhitelist?: boolean,
 * }}
 */
export const model__badgeType = {
	id: undefined,
	createdOn: undefined,
	name: '',
	description: '',
	instructions: [],
	paymentSubstitute: false,
	providesFreeCharging: false,
	partner: model__partnerNested,
	disableWhitelist: false,
};

/**
 * Badge model
 * ---
 * @type {{
 * 	id?: number,
 *	createdOn?: Date,
 *	badgeNumber?: string,
 *	customUserID?: string,
 *	notes?: string,
 *	removeAfterUse?: boolean,
 *	badgeType?: model__badgeType,
 *	user?: model__userAccountNested,
 * }}
 */
export const model__badge = {
	id: undefined,
	createdOn: undefined,
	badgeNumber: '',
	customUserID: '',
	notes: '',
	removeAfterUse: false,
	badgeType: model__badgeType,
	user: model__userAccountNested,
};

/**
 * User Account model
 * ---
 * @type {{
 * 	id?: number,
 *	createdOn?: Date,
 *	email: string,
 *	forename?: string,
 *	surname?: string,
 *	invoicingEmail?: string,
 *	accountName?: string,
 *	customID?: string,
 *	termsAccepted?: boolean,
 *	ivrPin?: string,
 *	locale?: string,
 *	hiddenDescription?: string,
 *	totpEnabled?: boolean,
 *	totpRequired?: boolean,
 *	accountState?: string,
 *	lastActivity?: Date,
 *	permissions: model__permissions,
 *	activePaymentMethod?: model__paymentMethod,
 *	activePaymentMethods?: model__paymentMethod[],
 *	businessDetails?: model__businessDetails,
 *	notificationConfiguration?: model__notificationConfiguration[],
 *	badges?: model__badgeNested[],
 *	notifications?: string[],
 *	partner?: model__partnerName,
 *	region?: model__regionNested,
 *	memberships?: model__membershipNested[],
 *	joinedAccounts?: model__accountJoin[],
 *	markSessionsAsDevelopment?: boolean,
 *	type?: string,
 *	alwaysPickCoupon?: boolean,
 *	alwaysRequireCoupon?: boolean,
 *	defaultKwhLimit?: number,
 *	configuredExternalLogins?: string[],
 *	allowedLoginMethods?: string[],
 *	unresolvedSessions?: model__unresolvedSession[],
 *	groupPayEnabled?: boolean,
 *	companyProfile?: boolean,
 *	disableEditing?: boolean,
 *	enterpriseUser?: model__scimEnterpriseUser,
 *	deletionAvailability?: string,
 * }}
 */
export const model_user = {
	activePaymentMethods: [],
	businessDetails: null,
	email: null,
	forename: null,
	hiddenDescription: null,
	ivrPin: null,
	locale: null,
	memberships: null,
	notifications: null,
	partner: null,
	permissions: {
		roleType: "USER",
	},
	region: null,
	roleType: null,
	surname: null,
	totpEnabled: false,
	accountState: E_UserAccountState.ACTIVE,
};

export const model_default_permissions = {
	changeLogNotifications: "READ",
	coupons: "READ",
	faq: "READ",
	feedback: "READ",
	handleUserPersonalData: false,
	locationRelease: false,
	locations: "READ",
	memberships: "READ",
	partners: "READ",
	sessions: "READ",
	showUsersFromAllRegions: false,
	tariffs: "READ",
	tokens: "READ",
	unitControl: false,
	units: "READ",
	users: "READ",
};

export const model_admin_permissions = {
	changeLogNotifications: "READ",
	coupons: "READ_WRITE",
	faq: "READ_WRITE",
	feedback: "READ",
	handleUserPersonalData: true,
	locationRelease: true,
	locations: "READ_WRITE",
	memberships: "READ_WRITE",
	partners: "READ_WRITE",
	sessions: "READ_WRITE",
	showUsersFromAllRegions: true,
	tariffs: "READ_WRITE",
	tokens: "READ",
	unitControl: true,
	units: "READ_WRITE",
	users: "READ_WRITE"
}

export const model_document = {
	name: null,
	filename: null,
	description: null,
	visibility: "ADMINS_ONLY"
};

export const model_token = {
	tokenNumber: null,
	partner: null,
	region: null,
	description: null,
	/**
	 * @type "RFID"|"OTHER"
 	 */
	type: "RFID",
	enabled: true,
	allowedConnectors: [],
};

export const model_badge_whitelist = {
	badgeNumber: null,
	customUserID: null,
	notes: null
};

export const model_membership = {
	titles: [],
	descriptions: [],
	partner: null,
	enabledConnectors: [],
};

/**
 * Period a group payment charging limit is counted over.
 */
export const E_ChargingLimitPeriod = {
	DAY: "DAY",
	WEEK: "WEEK",
	MONTH: "MONTH",
	TOTAL: "TOTAL",
};

export const E_PaymentMethod = {
	TRANSFER: "TRANSFER",
	CARD: "CARD",
	CASH: "CASH",
	CONTRACT: "CONTRACT",
	OTHER: "OTHER",
	NETTING_OUT: "NETTING_OUT",
	ROUNDING: "ROUNDING",
};

/**
 * @type {{paymentNote: String, paymentMethod: String, paidOn: String}}
 */
export const model_paymentInfo = {
	paidOn: null,
	paymentMethod: E_PaymentMethod.TRANSFER,
	paymentNote: null,
	amount: null,
	currency: null,
	bankAccount: {},
	variableSymbol: null,
	specificSymbol: null,
};

/**
 * @type {{chargePointIdentity: string, connectionLossTimeoutSeconds: number, localListEnabled: boolean, authorizeRemoteStartRequest: boolean, allowAllIdTags: boolean, serverAddress: string, currentBalancingPartIncrement: number, meterValueSampleIntervalSeconds: number, connectionLossRetryIntervalSeconds: number, ocppVersion: string, vendor: string, connectionTimeoutSeconds: number, currentBalancingMode: string, id: number, firmwareVersion: string, acceptUnsignedCertificates: boolean, chargerAddress: string, chargePointModel: string, numberOfConnectors: number, supportReservations: boolean, externalStartIdTag: string, allowOfflineTxForUnknownId: boolean, localListVersion: number, heartbeatIntervalSeconds: number, currentLimit: number}}
 */
export const model_ocppConfiguration = {
  id: null,
  currentLimit: 0,
  numberOfConnectors: 0,
  connectionTimeoutSeconds: 0,
  currentBalancingMode: null,
  currentBalancingPartIncrement: 0,
  ocppVersion: "OCPP16_JSON",
  heartbeatIntervalSeconds: 0,
  meterValueSampleIntervalSeconds: 0,
  chargePointIdentity: null,
  chargePointModel: null,
  firmwareVersion: null,
  vendor: null,
  externalStartIdTag: null,
  serverAddress: null,
  chargerAddress: null,
  connectionLossTimeoutSeconds: 0,
  connectionLossRetryIntervalSeconds: 0,
  allowOfflineTxForUnknownId: false,
  allowAllIdTags: false,
  acceptUnsignedCertificates: false,
  localListEnabled: false,
  localListVersion: 0,
  authorizeRemoteStartRequest: false,
  supportReservations: false
};

/**
 * VehicleTemplate model
 * ---
 * @type {{
 * 	id?: number,
 * 	createdOn?: Date,
 * 	name: string,
 * 	visible?: boolean,
 * 	brandName?: string,
 * 	modelName?: string,
 * 	defaultBatteryCapacity?: number,
 * 	defaultRangeKm?: number,
 * 	defaultTemplate?: boolean,
 * 	image: model__Image,
 * 	imageMask: model__Image,
 * 	acStandard?: model__connectorStandard,
 * 	dcStandard?: model__connectorStandard
 * }}
 */
export const model_vehicleTemplate = {
	id: undefined,
	createdOn: undefined,
	name: null,
	visible: true,
	brandName: null,
	modelName: null,
	defaultBatteryCapacity: 0,
	defaultRangeKm: 0,
	defaultTemplate: true,
	image: null,
	imageMask: null,
	acStandard: null,
	dcStandard: null,
};

export const model_vehicle = {
	name: null,
	vehicleTemplate: {},
	batteryCapacity: null,
	rangeKm: null,
	color: "#ffffff",
	partner: null,
	user: null,
};

export const model__reminder = {
	enabled: "true",
	title: null,
	description: null,
	type: "ONE_TIME",
	triggerPeriodDays: null,
}

export const E_ClusterStrategy = {
	EQUAL_SESSION_SPLIT: "EQUAL_SESSION_SPLIT",
	EQUAL_CONNECTOR_SPLIT: "EQUAL_CONNECTOR_SPLIT",
}

export const model__clusterPeriod = {
	defaultPeriod: false,
	unit: "KW",
	timezone: "Europe/Prague",
	maximumValuePercentage: 100,
	maximumValue: 0,
	maximumSessions: 0,
	strategy: E_ClusterStrategy.EQUAL_CONNECTOR_SPLIT,
	strategyWeight: null,
}

export const model__cluster = {
	name: null,
	description: null,
	enabled: null,
	partner: null,
	region: null,
	connectors: [],
	clusters: [],
	periods: [],
	parentCluster: null,
	dynamicMaximumValue: null,
	dynamicMaximumValuePercentage: null,
	dynamicMaximumSessions: null,
};

export const E_LocationDeviceType = {
	CHARGER_STAND: "CHARGER_STAND",
	CHARGER_WALLBOX: "CHARGER_WALLBOX",
	CHARGER_BOX: "CHARGER_BOX",
	CHARGER_STAND_BOX_COMBO: "CHARGER_STAND_BOX_COMBO",
	ELECTRIC_METER: "ELECTRIC_METER",
	BATTERY_PACK: "BATTERY_PACK",
	OTHER: "OTHER",
};

const model__locationDeviceShared = {
	name: null,
	description: null,
};


/**
 * SIM configuration type enum
 * ---
 * @enum string
 * @readonly
 */
export const E_SIMConfiguration_Type = {
	ESIM: "ESIM",
	PHYSICAL: "PHYSICAL",
};


/**
 * SIM configuration billingMode enum
 * ---
 * @enum string
 * @readonly
 */
export const E_SIMConfiguration_BillingMode = {
	BILLED: "BILLED",
	NOT_BILLED: "NOT_BILLED",
};

/**
 * SIM configuration model
 * ---
 * @type {{
 * 	type?: E_SIMConfiguration_Type,
 * 	operator?: string,
 * 	imei?: string,
 * 	phoneNumber?: string,
 * 	owner?: string,
 * 	activeSince?: Date,
 * 	billingMode?: E_SIMConfiguration_BillingMode
 * }}
 */
export const model__SIMConfiguration = {
	type: E_SIMConfiguration_Type.ESIM,
	operator: '',
	imei: '',
	phoneNumber: '',
	owner: '',
	activeSince: undefined,
	billingMode: E_SIMConfiguration_BillingMode.BILLED,
};


/**
 * POS selection mode type enum
 * ---
 * @enum string
 * @readonly
 */
export const E_POSSelectionMode_Type = {
	LIST_STAND: "LIST_STAND",
	LIST_CONNECTOR: "LIST_CONNECTOR",
	INPUT_CONNECTOR: "INPUT_CONNECTOR",
};

/**
 * POS configuration model
 * ---
 * @type {{
 * }}
 */
export const model__POSConfiguration = {
	stateOverride: null,
	evseFilter: '',
	connectorFilter: '',
	selectionMode: E_POSSelectionMode_Type.LIST_CONNECTOR,
	showSplashScreen: true,
	enableRFID: false,
	enablePayment: true,
	authorizeStop: true,
	enableInvoiceQR: true,
	enableAppOffer: true,
	enableAppPairing: true,
	appPairingTimeLimitSeconds: 600,
	customAppQR: null,
	customAppName: null,
	defaultLocale: null,
};


/**
 * POS availability state override type enum
 * ---
 * @enum string
 * @readonly
 */
export const E_POSAvailabilityState_Type = {
	AVAILABLE: "AVAILABLE",
	NOT_AVAILABLE_OUT_OF_ORDER: "NOT_AVAILABLE_OUT_OF_ORDER"
}

/**
 * POS payment provider type enum
 * ---
 * @enum string
 * @readonly
 */
export const E_POSPaymentProvider_Type = {
	CSOB_ECR: "CSOB_ECR",
	GPE_ORCHESTRATOR: "GPE_ORCHESTRATOR"
}

/**
 * Device warranty model
 * ---
 * @type {{
 * 	months?: number,
 * 	expiresAt?: Date,
 * 	notes?: string
 * }}
 */
export const model__deviceWarranty = {
	months: 0,
	expiresAt: undefined,
	notes: '',
};

/**
 * Location device model
 * ---
 * @type {{
 * 	id?: number,
 * 	createdOn?: Date,
 * 	name: string,
 * 	description?: string,
 * 	template?: model__deviceTemplate,
 * 	serialNumber?: string,
 * 	manufacturer?: string,
 * 	model?: string,
 * 	manufacturedOn?: Date,
 * 	owner?: string,
 * 	type: E_LocationDeviceType,
 * 	unitType?: string,
 * 	warranty?: model__deviceWarranty,
 * 	warrantyExpired?: boolean,
 * 	components?: model__locationDevice_component[],
 * }}
 */
export const model__locationDevice = {
	...model__locationDeviceShared,
	serialNumber: null,
	manufacturer: null,
	model: null,
	manufacturedOn: null,
	owner: null,
	type: E_LocationDeviceType.CHARGER_STAND,
	components: [],
	warranty: model__deviceWarranty,
	warrantyExpired: false,
};

/**
 * Device component enum
 * ---
 * @enum string
 * @readonly
 */
export const E_Device_ComponentType = {
	CUSTOM: "CUSTOM",
	CONNECTOR: "CONNECTOR",
	SIM_CARD: "SIM_CARD",
	POINT_OF_SALE: "POINT_OF_SALE",
	MEKH: "MEKH",
};

/**
 * Occasion a device acceptance protocol is filled in on
 * ---
 * @enum string
 * @readonly
 */
export const E_Device_AcceptanceProtocolType = {
	GENERAL: "GENERAL",
	INSTALLATION: "INSTALLATION",
	SERVICE: "SERVICE",
};

/**
 * MEKH grid connection type enum
 * ---
 * @enum string
 * @readonly
 */
export const E_MEKHConfiguration_GridConnectionType = {
	PUBLIC_DISTRIBUTION_NETWORK: "PUBLIC_DISTRIBUTION_NETWORK",
	PRIVATE_LINE: "PRIVATE_LINE",
	USER_INSTALLATION: "USER_INSTALLATION",
};

/**
 * MEKH reported status enum
 * ---
 * @enum string
 * @readonly
 */
export const E_MEKHConfiguration_Status = {
	IN_OPERATION: "IN_OPERATION",
	PLANNED: "PLANNED",
	DECOMMISSIONED: "DECOMMISSIONED",
};

/**
 * Master data reported to the Hungarian energy regulator that cannot be derived from the rest of the system.
 * A device carrying this component is included in the MEKH reports.
 */
export const model__MEKHConfiguration = {
	mekhIdentifier: null,
	landRegistryNumber: null,
	gridConnectionType: null,
	commissionedOn: undefined,
	decommissionedOn: undefined,
	bidirectionalChargingCapable: false,
	heavyDutyVehicleCapable: false,
	barrierFreeAccess: false,
	disabledParkingSpaces: 0,
	requiredPowerKw: null,
	smartChargingCapable: null,
	status: null,
	note: null,
};

export const model__locationDevice_component = {
	...model__locationDeviceShared,
	serialNumber: null,
	iconReference: "dashboard",
	colorReference: "#000000",
	variables: [],
	type: E_Device_ComponentType.CUSTOM,
	connectorConfiguration: null,
	simConfiguration: null,
	posConfiguration: null,
	mekhConfiguration: null
};
export const model__locationDevice_variable_attribute = {
	value: null,
}

export const model__locationDevice_variable = {
	...model__locationDeviceShared,
	attributes: [model__locationDevice_variable_attribute],
}

/**
 * Header Item
 * ---
 * Table listing header item.
 *
 * Some props are used in another listings as well (search)
 * @type {{
 *  filter: Boolean,
 *  visible: Boolean,
 *  width: Number|String,
 *  label: String|Function|Element,
 *  icon: String|Function|Element,
 *  sort: Boolean,
 *  path: String,
 *  field: String,
 *  key: String,
 *  canModify: Boolean,
 *  metaLabel: String|Function|Element,
 *  restricted: Object|Boolean|function(item),
 *  horizontalAlign: "flex-start"|"flex-end"|"center",
 *  verticalAlign: "flex-start"|"flex-end"|"center",
 *  handledBySearch: boolean,
 *  hideStripe: boolean,
 *  alias: null|string|model__listingHeaderItem,
 * }}
 */
export const model__listingHeaderItem = {
	//Metadata to inform that this item was already processed.
	// Most likely via {...model__listingHeaderItem} and thus no need to do it again.
	__processed__: true,
	__hiddenByDefault__: false,
	label: null,
	icon: null,
	filter: true,
	sort: true,
	visible: true,
	// css flex: {value} or max-width: {value} if {value} is not a Number
	width: 3,
	field: null,
	//Optional, will be generated at runtime if missing
	key: null,
	//If true, this column can toggle it's visibility in table settings
	canModify: true,
	//Label used in other places, like table settings.
	metaLabel: null,
	restricted: false,
	// (justify-content) flex align options (e.g. "flex-start"|"flex-end"|"center", ...)
	horizontalAlign: null,
	// (align-items) flex align options (e.g. "flex-start"|"flex-end"|"center", ...)
	verticalAlign: null,
	//If true, header item will not be constructed as a search filter
	handledBySearch: false,
	//If true and the header is visible, hides .diamond-row's status stripe
	hideStripe: false,
	//Header item to alias (either null, a string pointer to the header.key or the header.field, or the actual header item with the data)
	alias: null,
	//If true, a simpler LIKE search param will be sent (e.g. %text%) instead of per character one (e.g. %t%%e%%x%%t%)
	lessFuzzySearch: false,
};

export const model__listingOptions = {
	//Request service
	service: (query, signal) => Promise.resolve([]),
	//Querystring data passed most likely from page.js router
	queryString: null,
	//Interval upon which the listing is refreshed periodically; refreshInterval <= 0 => no refresh
	refreshInterval: 10000,//10s
	/**
	 * Filters data. Can be set here or manually via element attribute (e.g. filters=[[listingFilters]])
	 * @type M_Filter_Definition[]
	 */
	filters: [],
	/**
	 * Same as **filters** but instead of full filter item data, there is only {field: String, value: String, operator: String}.
	 * These filters should be listed in diamond-filters as a READ ONLY! but can be cleared via "clear all filters" option
	 */
	legacyFilters: [],
	/**
	 * Static filters.
	 * Static filters that are provided along filters which are dynamic.
	 * Filters can be constructed with **key** property which points to specific headerData or directly set with **field**.
	 * ```
	 *  Examples:
	 *  headerData = {
	 *      key: "test",
	 *      field: "abc",
	 *      operator: "!=",
	 *      ...
	 *  }
	 *
	 *  //Key is defined, thus field & operator are filled from headerData
	 *  staticFilters = [{key: "test", value: "1"}] => [{field: "abc", operator: "!=", value: "1"}]
	 *
	 *  //Key is not present thus default data is applied for missing properties
	 *  staticFilters = [{field: "test", value: 2}] => [{field: "test", operator: "=", value: 2}]
	 *
	 *  //Will override field and fill != from headerData
	 *  staticFilters = [{key: "test", field: "test", value: 2}] => [{field: "test", operator: "!=", value: 2}]
	 * ```
	 * @type M_Filter_Definition[]
	 */
	staticFilters: [],
	/**
	 * Filter values. Initial filter values in case the URL query cannot be used.
	 */
	filterValues: {},
	defaultFormula: undefined,
	/**
	 * Default count of items per page
	 */
	defaultSize: 10,
	/**
	 * Notify URL query. If true, every change in listingData (filters, search, sort, page) will be written to URL query.
	 */
	notifyQuery: true,
	/**
	 * Use URL query. Whether to load data from the URL query when the listing is initializing.
	 */
	useQuery: true,
	totalPagesService: () => Promise.resolve(1),
	/**
	 * Create entity object.
	 * If defined, diamond listing will display an add button at the left top side
	 * @type {{
	 *     label: String,
	 *     restricted: Object|Boolean|function(),
	 *     href: String,
	 *     action: function()
	 * }}
	 */
	createEntity: null,
	/**
	 * Allow cache.
	 * Allows usage of caching system while changing the pages.
	 */
	allowCache: true,
	/**
	 * Pinned query read only.
	 * If false, pinned items update won't trigger page.js's page update. (History will still be updated on every change)
	 */
	pinnedQueryReadOnly: false,
	/**
	 * Keep pinned position.
	 * If true, pinned item will keep position with it's origin (same as received from the server)
	 */
	keepPinnedPosition: true,
	/**
	 * Listing styles
	 */
	style: {
		/**
		 * Filters icon
		 */
		filtersIcon: 'filter-list',
	},
};

export const model__listingData = {
	/**
	 * Active sort
	 * @type {{field: String, key?: String, direction: String}}
	 */
	sort: null,
	/**
	 * Search string
	 * @type String
	 */
	search: null, //Search input value
	/**
	 * Active page
	 */
	page: 0,
	/**
	 * Active size
	 */
	size: 10,

	/**
	 * Pending state is total pages is -1
	 */
	loadingTotalPages: false,
	maxPaginationItems: 5,
	cache: {},
};

export const model__listingContent = {
	content: [],
	empty: false,
	first: true,
	last: true,
	number: 0,
	numberOfElements: 0,
	pageable: {},
	size: 20,
	sort: {},
	totalElements: 0,
	/**
	 * Total pages count
	 * If -1, the pages are either unknown or needs to be downloaded separately.
	 *  - If unknown, there should be no pagination for pages, only forward and backward arrow buttons.
	 *  - If unknown but can be downloaded, show same behavior as with unknown but add spinner for total pages
	 */
	totalPages: -1,
};

export const model__urlQueryDelimiters = {
	FILTERS_VALUE_VALUE: "~",
}

export const E_ParasiteComponentModifierType = {
	AMOUNT_ABOVE: "AMOUNT_ABOVE",
	AMOUNT_BELOW: "AMOUNT_BELOW",
};

export const E_ParasiteComponentModifierEntity = {
	KWH: "KWH",
	CONNECTOR: "CONNECTOR",
	LOCATION: "LOCATION",
};

export const model__parasiteComponentModifier = {
	id: undefined,
	createdOn: undefined,
	type: E_ParasiteComponentModifierType.AMOUNT_ABOVE,
	entity: null,
	value: 0,
};

export const E_ParasiteTariffComponentType = {
	FLAT: "FLAT",
	PERCENT_FROM_TOTAL_PARTNER_FEE: "PERCENT_FROM_TOTAL_PARTNER_FEE",
	PERCENT_PUBLIC_CONNECTORS: "PERCENT_PUBLIC_CONNECTORS",
	PERCENT_PRIVATE_CONNECTORS: "PERCENT_PRIVATE_CONNECTORS",
	PERCENT_PUBLIC_LOCATIONS: "PERCENT_PUBLIC_LOCATIONS",
	PERCENT_PRIVATE_LOCATIONS: "PERCENT_PRIVATE_LOCATIONS",
	PERCENT_IDENTIFIERS: "PERCENT_IDENTIFIERS",
	SESSION_PRICE_PERCENT: "SESSION_PRICE_PERCENT",
}

export const model__parasiteTariffComponent = {
	id: undefined,
	createdOn: undefined,
	type: E_ParasiteTariffComponentType.FLAT,
	modifiers: [],
	value: 0,
	minimumValue: 0,
};

/**
 * @type {{
 *  minimumInvoiceValue: Number,
 *  components: model__parasiteTariffComponent[],
 *  hosts: [{id: Number, name: String}],
 *  name: String,
 *  description: String,
 *  id: Number,
 *  createdOn: Date,
 *  enabled: Boolean
 * }}
 */
export const model__parasiteTariff = {
	id: undefined,
	createdOn: undefined,
	enabled: true,
	name: null,
	description: null,
	hosts: [],
	minimumInvoiceValue: 0,
	components: [],
	timezone: null,
};

export const E_ChangelogCategory = {
	ANDROID: "ANDROID",
	IOS: "IOS",
	WEB: "WEB",
	BACKEND: "BACKEND",
	OTHER: "OTHER",
};

/**
 * Changelog entry
 * ---
 * @type {{
 *  id: Number,
 *  text: Array,
 *  categories: Array<E_ChangelogCategory>,
 *  createdOn: Date,
 *  version: String,
 * }}
 */
export const model__changelogEntry = {
	id: undefined,
	createdOn: undefined,
	text: [],
	version: null,
	categories: [],
};

/**
 * Device template
 * ---
 * @type {{
 *  id: undefined,
 *  createdOn: undefined
 *  name: string,
 *  defaultDevice: model__locationDevice,
 *  images: [],
 * }}
 */
export const model__deviceTemplate = {
	id: undefined,
	createdOn: undefined,
	name: '',
	defaultDevice: model__locationDevice,
	images: [],
}

export const model__filterInputOption = {
	label: "",
	value: null,
	restricted: false,
};

export const E_Period_Range = {
	TODAY: "TODAY",
	THIS_WEEK: "THIS_WEEK",
	THIS_MONTH: "THIS_MONTH",
	PREVIOUS_MONTH: "PREVIOUS_MONTH",
	//Isn't actually used as a value because it's replaced with a Date range
	CUSTOM: "CUSTOM",
	//Special case where no dates are to be used
	UNLIMITED: "Infinity",
};

/**
 * Period placeholders enum
 * ---
 * @enum string
 * @readonly
 */
export const E_Period_Placeholders = {
	DAY_START: "DAY_START",
	DAY_END: "DAY_END",
	WEEK_START: "WEEK_START",
	WEEK_END: "WEEK_END",
	MONTH_START: "MONTH_START",
	MONTH_END: "MONTH_END",
	YEAR_START: "YEAR_START",
	YEAR_END: "YEAR_END",
	YESTERDAY_START: "YESTERDAY_START",
	YESTERDAY_END: "YESTERDAY_END",
	LAST_WEEK_START: "LAST_WEEK_START",
	LAST_WEEK_END: "LAST_WEEK_END",
	LAST_MONTH_START: "LAST_MONTH_START",
	LAST_MONTH_END: "LAST_MONTH_END",
	LAST_YEAR_START: "LAST_YEAR_START",
	LAST_YEAR_END: "LAST_YEAR_END"
};

export const E_Granularity = {
	HOURLY: "HOURLY",
	DAILY: "DAILY",
	WEEKLY: "WEEKLY",
	MONTHLY: "MONTHLY",
};

/**
 * Bank account transaction direction enum
 * ---
 * @enum string
 * @readonly
 */
export const E_BankAccount_Transaction_Direction = {
	OUTGOING: "OUTGOING",
	INCOMING: "INCOMING",
};

/**
 * Bank account transaction source enum
 * ---
 * @enum string
 * @readonly
 */
export const E_BankAccount_Transaction_Source = {
	REPORT: "REPORT",
	MANUAL: "MANUAL",
};

/**
 * Bank account transaction type enum
 * ---
 * @enum string
 * @readonly
 */
export const E_BankAccount_Transaction_Type = {
	POLYFAZER_SESSIONS: "POLYFAZER_SESSIONS",
	POLYFAZER_PARTNER: "POLYFAZER_PARTNER",
	POLYFAZER_PARASITE: "POLYFAZER_PARASITE",
	POLYFAZER_BANK_FEE: "POLYFAZER_BANK_FEE",
	COSTS_POLYFAZER: "COSTS_POLYFAZER",
	POLYFAZER_PROFIT: "POLYFAZER_PROFIT",
	POLYFAZER_OTHER: "POLYFAZER_OTHER",
	BANK_FEE: "BANK_FEE",
	POLYFAZER_GROUP_MEMBERSHIP: "POLYFAZER_GROUP_MEMBERSHIP",
	COSTS_OTHER: "COSTS_OTHER",
	OTHER: "OTHER",
	IGNORE: "IGNORE",
	UNKNOWN: "UNKNOWN",
};

/**
 *
 * @type {{bankTransactionID: string,
 *  identifiedAt: Date,
 *  amount: number,
 *  notes: string,
 *  source: E_BankAccount_Transaction_Source,
 *  transactionDate: Date,
 *  type: E_BankAccount_Transaction_Type,
 *  createdOn: Date,
 *  constantSymbol: string,
 *  variableSymbol: string,
 *  specificSymbol: string,
 *  remoteAccountName: string,
 *  remoteAccountNumber: string,
 *  id: number,
 *  accountBalance: number,
 *  identifiedBy: model_user,
 *  direction: E_BankAccount_Transaction_Direction
 * }}
 */
export const model__bankAccountTransaction = {
	id: undefined,
	createdOn: undefined,
	accountBalance: null,
	bankTransactionID: null,
	transactionDate: undefined,
	amount: null,
	variableSymbol: null,
	specificSymbol: null,
	constantSymbol: null,
	remoteAccountName: null,
	remoteAccountNumber: null,
	notes: null,
	identifiedBy: null,
	identifiedAt: undefined,
	direction: E_BankAccount_Transaction_Direction.INCOMING,
	source: E_BankAccount_Transaction_Source.MANUAL,
	type: E_BankAccount_Transaction_Type.UNKNOWN,
};

/**
 *
 * @type {{
 *  csobBusinessConnectorEnabled: boolean,
 *  notes: string,
 *  balance: number,
 *  name: string,
 *  details: model__bankAccountDetails,
 *  currency: model__currency,
 *  id: number,
 *  createdOn: Date,
 *  csobContractNumber: number,
 *  csobMerchantReportId: string,
 *  csobMerchantReportLastDownload: Date,
 * }}
 */
export const model__bankAccount = {
	id: undefined,
	createdOn: undefined,
	name: null,
	details: model__bankAccountDetails,
	csobBusinessConnectorEnabled: false,
	csobContractNumber: null,
	csobMerchantReportId: null,
	notes: null,
	currency: model__currency,
	balance: 0,
};

/**
 * A single report of the bank's POSMerchant system that is downloaded automatically and mailed to its recipients.
 * @type {{
 *  id: number,
 *  enabled: boolean,
 *  name: string,
 *  reportId: string,
 *  emails: string,
 *  locale: string,
 *  lastDownload: Date,
 * }}
 */
export const model__posMerchantReportConfiguration = {
	enabled: true,
	name: null,
	reportId: null,
	emails: null,
	locale: null,
};

export const E_AsyncExportState = {
	WAITING: "WAITING",
	RUNNING: "RUNNING",
	FINISHING: "FINISHING",
	COMPLETED: "COMPLETED",
	ERROR: "ERROR",
	_CANCELLING: "_CANCELLING",
	CANCELLED: "CANCELLED",
};

export const model__asyncExport = {
	id: undefined,
	createdOn: undefined,
	filename: null,
	percent: -1,
	state: E_AsyncExportState.WAITING,
};

/**
 * Invoice email type filter enum
 * ---
 * @enum string
 * @readonly
 */
export const E_InvoiceEmail_TypeFilter = {
	POLYFAZER_PAYS_PARTNER: "POLYFAZER_PAYS_PARTNER",
	PARTNER_PAYS_POLYFAZER: "PARTNER_PAYS_POLYFAZER",
	PARASITE: "PARASITE",
};

/**
 * Invoice email sub type filter enum
 * ---
 * @enum string
 * @readonly
 */
export const E_InvoiceEmail_SubTypeFilter = {
	INVOICE_REQUEST: "INVOICE_REQUEST",
	PAYMENT_ORDER: "PAYMENT_ORDER",
};

/**
 * Invoice email model
 * ---
 * @type {{
 *  email: string,
 *  locale: string,
 *  typeFilter: E_InvoiceEmail_TypeFilter[],
 *  subTypeFilter: E_InvoiceEmail_SubTypeFilter[],
 * }}
 */
export const model__invoiceEmail = {
	email: null,
	locale: 'cs',
	typeFilter: [],
	subTypeFilter: [],
	partnerFilter: null
}

export const E_Session_WarningLevel = {
	CRITICAL: "CRITICAL",
	MAJOR: "MAJOR",
	MINOR: "MINOR",
	INFO: "INFO"
};

/**
 * Export entity enum
 * ---
 * @enum string
 * @readonly
 */
export const E_ExportEntity = {
	SESSION: "SESSION",
	SESSION_HISTORY: "SESSION_HISTORY",
	USER: "USER",
	LOCATION: "LOCATION",
	UNIT: "UNIT",
	UNIT_EVENT: "UNIT_EVENT",
	EXTERNAL_LOCATION: "EXTERNAL_LOCATION",
	TOKEN: "TOKEN",
	PARTNER: "PARTNER",
	COUPON: "COUPON",
	COUPON_TEMPLATE: "COUPON_TEMPLATE",
	FEEDBACK: "FEEDBACK",
	PARTNER_INVOICE: "PARTNER_INVOICE",
	BANK_ACCOUNT_TRANSACTION: "BANK_ACCOUNT_TRANSACTION",
	TARIFF: "TARIFF",
	INVOICE_DATA: "INVOICE_DATA",
	INVOICE_REMINDER: "INVOICE_REMINDER",
	INVOICE: "INVOICE",
	MEMBERSHIP_INVOICE: "MEMBERSHIP_INVOICE",
	DEVICE: "DEVICE",
};

/**
 * OCPI client status enum
 * ---
 * @enum string
 * @readonly
 */
export const E_OCPIClient_Status = {
	SUSPENDED: "SUSPENDED",
	PENDING: "PENDING",
	REGISTERED: "REGISTERED",
	ACTIVE: "ACTIVE",
};

/**
 * Power type matched by a rule of the common tariff of an OCPI client.
 */
export const E_OCPIClient_TariffRulePowerType = {
	AC: "AC",
	DC: "DC",
};

/**
 * Session invoice refund data
 * ---
 * @type {{
 *  __items__?: Object<invoiceDataItemID: number, refundAmount: number>,
 *  refundItems: [{invoiceDataItemID: number, refundAmount: number}],
 *  notifyUser: boolean,
 *  refundText: [],
 *  additionalInvoiceEmails: string[]
 * }}
 */
export const model__sessionInvoiceRefundData = {
	__items__: [],
	refundItems: [],
	refundText: [],
	notifyUser: false,
	additionalInvoiceEmails: [],
};

/**
 * Unit log type enum
 * ---
 * @enum string
 * @readonly
 */
export const E_LogType = {
	COMBINED: "COMBINED",
	RAW: "RAW",
};

/**
 * Unit OCPP commands enum
 * ---
 * @enum string
 * @readonly
 */
export const E_Unit_OCPPCommand = {
	AVAILABILITY: "AVAILABILITY",
	RESET_SOFT: "RESET_SOFT",
	RESET_HARD: "RESET_HARD",
	GET_CONFIGURATION: "GET_CONFIGURATION",
	SET_CONFIGURATION: "SET_CONFIGURATION",
	DATA_TRANSFER: "DATA_TRANSFER",
	UNLOCK_CONNECTOR: "UNLOCK_CONNECTOR",
	TRIGGER_MESSAGE: "TRIGGER_MESSAGE",
	GET_DIAGNOSTICS: "GET_DIAGNOSTICS",
	GET_DIAGNOSTICS_CUSTOM_FTP: "GET_DIAGNOSTICS_CUSTOM_FTP",
	UPDATE_FIRMWARE: "UPDATE_FIRMWARE",
	DISPLAY_MESSAGE: "DISPLAY_MESSAGE",
	HIDE_DISPLAY_MESSAGE: "HIDE_DISPLAY_MESSAGE",
	GET_COMPOSITE_SCHEDULE: "GET_COMPOSITE_SCHEDULE",
	CLEAR_CHARGING_PROFILE: "CLEAR_CHARGING_PROFILE",
};

export const E_Unit_OCPPCommand_DisplayMessageType = {
	DIALOG: "DIALOG",
	TEXT: "TEXT",
	TOAST: "TOAST",
	CLEAR: "CLEAR",
};

export const E_Unit_OCPPCommand_DisplayMessageIcon = {
	NONE: "NONE",
	WARNING: "WARNING",
	ERROR: "ERROR",
	INFO: "INFO",
	PAYMENT: "PAYMENT",
	RFID: "RFID",
	VEHICLE: "VEHICLE",
};

export const model__unitOCPPCommandDisplayMessage = {
	messageID: null,
	title: null,
	message: null,
	button: null,
	type: E_Unit_OCPPCommand_DisplayMessageType.DIALOG,
	icon: E_Unit_OCPPCommand_DisplayMessageIcon.NONE,
	timeoutSeconds: null,
	connectorID: null,
	dismissible: true,
	showProgress: false,
};

export const model__unitOCPPCommandGetCompositeSchedule = {
	connectorID: null,
	duration: 3600,
	chargingRateUnit: "A",
};

/**
 * Bank account summary state enum
 * ---
 * @enum string
 * @readonly
 */
export const E_BankAccount_Summary_State = {
	DATA_REQUIRED: "DATA_REQUIRED",
	WAITING_FOR_RESOLUTION: "WAITING_FOR_RESOLUTION",
	RESOLVED: "RESOLVED",
};

/**
 * User type enum
 * ---
 * @enum string
 * @readonly
 */
export const E_User_Type = {
	POLYFAZER: "POLYFAZER",
	POLYFAZER_ANONYMOUS: "POLYFAZER_ANONYMOUS",
	SYGIC: "SYGIC",
	API_ACCOUNT: "API_ACCOUNT",
	EMBEDDED_APP: "EMBEDDED_APP",
	OTHER: "OTHER",
};

/**
 * Alternative identifier model
 * ---
 * @type {{
 *  id: number,
 *  identifierValue: string,
 *  description: string,
 * }}
 */
export const model__alternativeIdentifier = {
	id: null,
	identifierValue: "",
	description: ""
};

/**
 * Audit log entity type enum
 * ---
 * @enum string
 * @readonly
 */
export const E_AuditLog_EntityType = {
	PARTNER: "PARTNER",
	TARIFF: "TARIFF",
	PRODUCT: "PRODUCT",
	LOCATION: "LOCATION",
	INVOICE_DATA: "INVOICE_DATA",
	TRANSACTION_REFUND: "TRANSACTION_REFUND",
	TOKEN: "TOKEN",
	BANK_UPLOAD: "BANK_UPLOAD",
	SESSION: "SESSION",
	USER: "USER"
};

/**
 * Audit log event type enum
 * ---
 * @enum string
 * @readonly
 */
export const E_AuditLog_EventType = {
	CREATED: "CREATED",
	UPDATED: "UPDATED",
	DELETED: "DELETED",
	OTHER: "OTHER",
	SUSPENDED: "SUSPENDED",
	RESTORED: "RESTORED",
};

/**
 * FAQ visibility enum
 * ---
 * @enum string
 * @readonly
 */
export const E_FAQ_Visibility = {
	VISIBLE: "VISIBLE",
	HIDDEN_TO_PARTNERS: "HIDDEN_TO_PARTNERS",
	HIDDEN_TO_DRIVERS: "HIDDEN_TO_DRIVERS",
};

/**
 * FAQ category enum
 * @enum string
 * @readonly
 */
export const E_FAQ_Category = {
	CHARGING_TROUBLESHOOTING: "CHARGING_TROUBLESHOOTING",
	PAYMENT_TROUBLESHOOTING: "PAYMENT_TROUBLESHOOTING",
};

/**
 * FAQ device enum
 * ---
 * @enum string
 * @readonly
 */
export const E_FAQ_Device = {
	WEB: "WEB",
	IOS: "IOS",
	ANDROID: "ANDROID",
};

/**
 * FAQ model
 * ---
 * @type {{
 *  internalDescription: string,
 *  visibility: E_FAQ_Visibility,
 *  partner: model_partner|null,
 *  answer: [],
 *  iconReference: string,
 *  devices: E_FAQ_Device[],
 *  sortOrder: number,
 *  id: number,
 *  title: [],
 *  createdOn: Date,
 *  specialType: E_FAQ_Category,
 * }}
 */
export const model__faq = {
	id: undefined,
	createdOn: undefined,
	sortOrder: undefined,
	visibility: E_FAQ_Visibility.VISIBLE,
	partner: null,
	title: [],
	answer: [],
	devices: [
		E_FAQ_Device.WEB,
		E_FAQ_Device.IOS,
		E_FAQ_Device.ANDROID
	],
	internalDescription: null,
	iconReference: null,
	specialType: null,
};

/**
 * Connector value meter source type
 * ---
 * @enum string
 * @readonly
 */
export const E_Connector_ValueMeter_SourceType = {
	ADDITIVE: "ADDITIVE",
	CUMULATIVE: "CUMULATIVE",
};

/**
 * Connector value meter value type
 * ---
 * @enum string
 * @readonly
 */
export const E_Connector_ValueMeter_ValueType = {
	ENERGY: "ENERGY",
};

/**
 *
 * @type {{
 * note: string,
 * correctionReason: string,
 * author: model_user,
 * originalValue: number,
 * id: number,
 * correctedValue: number,
 * createdOn: Date
 * }}
 */
export const model__connectorValueMeterCorrection = {
	id: undefined,
	createdOn: undefined,
	originalValue: 0,
	correctedValue: 0,
	note: '',
	correctionReason: '',
	author: null,
};

/**
 *
 * @type {{
 *  id: number,
 *  createdOn: Date,
 *  snappedValue: number,
 *  snapshotTime: Date,
 *  note: string,
 *  author: model_user,
 * }}
 */
export const model__connectorValueMeterSnapshot = {
	id: undefined,
	createdOn: undefined,
	snappedValue: 0,
	snapshotTime: null,
	note: '',
	author: null,
};

/**
 * Connector value meter
 * ---
 * @type {{
 *  notes: string,
 *  serialNumber: string,
 *  connector: model_connector,
 *  sourceType: E_Connector_ValueMeter_SourceType,
 *  valueType: E_Connector_ValueMeter_ValueType,
 *  name: string,
 *  location: model_location,
 *  id: number,
 *  meterDeviceInfo: string,
 *  createdOn: Date,
 *  multipliedValue: number,
 *  rawValue: number,
 *  multiplier: number,
 *  lastValueUpdate: Date,
 *  corrections: model__connectorValueMeterCorrection[],
 *  snapshots: model__connectorValueMeterSnapshot[],
 * }}
 */
export const model__connectorValueMeter = {
	id: undefined,
	createdOn: undefined,
	location: null,
	connector: null,
	name: '',
	notes: '',
	serialNumber: '',
	meterDeviceInfo: '',
	sourceType: E_Connector_ValueMeter_SourceType.ADDITIVE,
	valueType: E_Connector_ValueMeter_ValueType.ENERGY,
	multipliedValue: 0,
	rawValue: 0,
	multiplier: 1,
	lastValueUpdate: null,
	corrections: [],
	snapshots: [],
};

/**
 * Billing state enum
 * ---
 * @enum string
 * @readonly
 */
export const E_Billing_State = {
	APPROVED: "APPROVED",
	PENDING: "PENDING",
	DECLINED: "DECLINED",
};

/**
 * Billing payment state enum
 * ---
 * @enum string
 * @readonly
 */
export const E_Billing_PaymentState = {
	OVERPAID: "OVERPAID",
	FULLY_PAID: "FULLY_PAID",
	PARTIALLY_PAID: "PARTIALLY_PAID",
	NOT_PAID: "NOT_PAID",
};

/**
 * Billing type enum
 * ---
 * @enum string
 * @readonly
 */
export const E_Billing_Type = {
	POLYFAZER_PAYS_PARTNER: "POLYFAZER_PAYS_PARTNER",
	PARTNER_PAYS_POLYFAZER: "PARTNER_PAYS_POLYFAZER",
	PARASITE: "PARASITE",
	MEMBERSHIP: "MEMBERSHIP",
};

/**
 * Upload feature availability
 * ---
 * @enum string
 * @readonly
 */
export const E_Upload_Availability = {
	AVAILABLE: "AVAILABLE",
	MISSING_CONFIGURATION: "MISSING_CONFIGURATION",
	HIDDEN: "HIDDEN",
};

/**
 * Billing subtype enum
 * ---
 * @enum string
 * @readonly
 */
export const E_Billing_Subtype = {
	INVOICE_REQUEST: "INVOICE_REQUEST",
	PAYMENT_ORDER: "PAYMENT_ORDER",
};

/**
 * Accounts receivable reminder (notice) state enum
 * ---
 * @enum string
 * @readonly
 */
export const E_AccountsReceivableReminder_State = {
	PENDING: "PENDING",
	INVALID: "INVALID",
	RESOLVED: "RESOLVED",
};

/**
 * Create accounts receivable reminder (notice) model
 * ---
 * @type {{
 *  reminderNumber: number,
 *  invoiceIDs: number[],
 *  parentID: number,
 * }}
 */
export const model__accountsReceivableCreateReminder = {
	reminderNumber: 1,
	invoiceIDs: [],
	parentID: undefined,
	invoicingPartnerID: undefined,
};


/**
 * Email template template enum
 * ---
 * @enum string
 * @readonly
 */
export const E_EmailTemplate_Template = {
	TEMPLATE_FRAGMENTS: "TEMPLATE_FRAGMENTS",
	BILLING_CLOSE_ERROR: "BILLING_CLOSE_ERROR",
	CHARGING_ERROR: "CHARGING_ERROR",
	DAILY_CHARGING_STATISTICS: "DAILY_CHARGING_STATISTICS",
	ENTITY_CHANGED: "ENTITY_CHANGED",
	FEEDBACK_CHANGED_STATE: "FEEDBACK_CHANGED_STATE",
	FEEDBACK_COMMENT: "FEEDBACK_COMMENT",
	FEEDBACK_OVERDUE: "FEEDBACK_OVERDUE",
	FORGOTTEN_PASSWORD: "FORGOTTEN_PASSWORD",
	INTERNAL_SERVER_ERROR: "INTERNAL_SERVER_ERROR",
	INVITATION: "INVITATION",
	MONTHLY_CHARGING_STATISTICS: "MONTHLY_CHARGING_STATISTICS",
	MONTHLY_DRIVER_INVOICES: "MONTHLY_DRIVER_INVOICES",
	NEW_FEEDBACK: "NEW_FEEDBACK",
	NON_STANDARD_NIKOLA_INTERRUPT: "NON_STANDARD_NIKOLA_INTERRUPT",
	PAYMENT_ERROR: "PAYMENT_ERROR",
	REGION_INVOICE_REPORT: "REGION_INVOICE_REPORT",
	REGISTRATION_SUCCESS: "REGISTRATION_SUCCESS",
	REMINDER: "REMINDER",
	SESSION_WARNING: "SESSION_WARNING",
	TERMINAL_PAYMENT: "TERMINAL_PAYMENT",
	UNIT_AVAILABLE: "UNIT_AVAILABLE",
	UNIT_UNAVAILABLE: "UNIT_UNAVAILABLE",
	INVOICE_REMINDER: "INVOICE_REMINDER",
	AUTO_EXPORT_NOTIFICATION: "AUTO_EXPORT_NOTIFICATION",
};


/**
 * Email template model
 * ---
 * @type {{
 * 	id?: number,
 * 	createdOn?: Date,
 * 	name?: string,
 * 	description?: string,
 * 	partner?: model_partner,
 * 	template: E_EmailTemplate_Template,
 * 	content: string,
 * }}
 */
export const model__emailTemplate = {
	id: undefined,
	createdOn: undefined,
	name: '',
	description: '',
	partner: null,
	template: E_EmailTemplate_Template.TEMPLATE_FRAGMENTS,
	content: '',
};


/**
 * Email message model
 * ---
 * @type {{
 * 	id?: number,
 * 	createdOn?: Date,
 * 	language: {
 * 	    id: number,
 * 	    languageCode: string,
 * 	    displayName: string,
 * 	    createdOn: Date,
 * 	},
 * 	partner?: model_partner,
 * 	content: string,
 * }}
 */
export const model__emailTranslation = {
	id: undefined,
	createdOn: undefined,
	language: null,
	partner: null,
	content: '',
};

/**
 * Feedback user assignment type
 * ---
 * @enum string
 * @readonly
 */
export const E_FeedbackUserAssignmentType = {
	SUPERVISION: "SUPERVISION",
	CUSTOMER: "CUSTOMER",
	REPORTER: "REPORTER",
	PERFORMED_BY: "PERFORMED_BY",
};

/**
 * Feedback user assignment model
 * ---
 * @type {{
 *  id: number,
 *  assignee: model_user,
 *  locale: string,
 *  type: E_FeedbackUserAssignmentType,
 *  createdOn: Date,
 *  email: string,
 *  notificationsEnabled: boolean,
 * }}
 */
export const model__feedbackUserAssignment = {
	id: undefined,
	createdOn: undefined,
	assignee: null,
	email: '',
	locale: '',
	type: E_FeedbackUserAssignmentType.CUSTOMER,
	notificationsEnabled: true,
};

/**
 * Feedback comment model
 * ---
 * @type {{
 *  visibleToCustomer: boolean,
 *  replyTo: number,
 *  comment: string,
 *  id: number,
 *  createdOn: Date,
 *  hasDocuments: boolean
 * }}
 */
export const model__feedbackComment = {
	id: undefined,
	createdOn: undefined,
	comment: '',
	replyTo: null,
	visibleToCustomer: true,
	hasDocuments: false,
};

/**
 * Feedback comment state
 * ---
 * @enum string
 * @readonly
 */
export const E_FeedbackCommentState = {
	POSTED: "POSTED",
	DELETED: "DELETED",
};


/**
 * Feedback state enum
 * ---
 * @enum string
 * @readonly
 */
export const E_Feedback_State = {
	NEW: "NEW",
	BEING_RESOLVED: "BEING_RESOLVED",
	OVERDUE: "OVERDUE",
	INVALID: "INVALID",
	RESOLVED: "RESOLVED",
	EXTERNAL: "EXTERNAL",
};


/**
 * Feedback category enum
 * ---
 * @enum string
 * @readonly
 */
export const E_Feedback_Category = {
	USER_REPORT: "USER_REPORT",
	SERVICE_REQUEST: "SERVICE_REQUEST",
	OTHER: "OTHER",
};


/**
 * Feedback model
 * ---
 * @type {{
 * 	id?: number,
 * 	createdOn?: Date,
 * 	subject?: string,
 * 	description?: string,
 * 	images?: [],
 * 	reporter?: model_user,
 * 	location?: model_location,
 * 	partner?: model_partner,
 * 	region?: model_region,
 * 	demandResponse?: boolean,
 * 	comment?: string,
 * 	state: E_Feedback_State,
 * 	category?: E_Feedback_Category,
 * 	timeLimit?: Date,
 * }}
 */
export const model__feedback = {
	id: undefined,
	createdOn: undefined,
	subject: '',
	description: '',
	images: [],
	reporter: null,
	location: null,
	partner: null,
	region: null,
	demandResponse: true,
	comment: '',
	state: E_Feedback_State.NEW,
	category: E_Feedback_Category.USER_REPORT,
	timeLimit: null,
};


/**
 * InfoText configuration type enum
 * ---
 * @enum string
 * @readonly
 */
export const E_InfoText_Type = {
	TERMS_AND_CONDITIONS: "TERMS_AND_CONDITIONS",
	CONTACT: "CONTACT",
	INFO: "INFO"
};

/**
 * Info text theme enum
 * ---
 * @enum string
 * @readonly
 */
export const E_InfoText_Theme = {
	LIGHT: "LIGHT",
	DARK: "DARK",
};

/**
 * InfoText model
 * ---
 * @type {{
 * 	id?: number,
 * 	createdOn?: Date,
 * 	textValue: string,
 * 	locale: string,
 * 	country?: string,
 * 	type: E_InfoText_Type,
 * 	theme: E_InfoText_Theme|null,
 * }}
 */
export const model__infoText = {
	id: undefined,
	createdOn: undefined,
	textValue: '',
	locale: '',
	country: '',
	type: E_InfoText_Type.TERMS_AND_CONDITIONS,
	theme: null,
};


/**
 * Refund queue item state enum
 * ---
 * @enum string
 * @readonly
 */
export const E_RefundQueueItem_State = {
	PENDING: "PENDING",
	APPROVED: "APPROVED",
	REJECTED: "REJECTED",
	CANCELLED: "CANCELLED",
	ERROR: "ERROR",
};

/**
 * Connector reported status status enum
 * ---
 * @enum string
 * @readonly
 */
export const E_Connector_ReportedStatus_Status = {
	AVAILABLE: "AVAILABLE",
	PREPARING: "PREPARING",
	CHARGING: "CHARGING",
	SUSPENDED_EVSE: "SUSPENDED_EVSE",
	SUSPENDED_EV: "SUSPENDED_EV",
	FINISHING: "FINISHING",
	RESERVED: "RESERVED",
	UNAVAILABLE: "UNAVAILABLE",
	FAULTED: "FAULTED",
};

/**
 * Connector reported status error code enum
 * ---
 * @enum string
 * @readonly
 */
export const E_Connector_ReportedStatus_ErrorCode = {
	CONNECTOR_LOCK_FAILURE: "CONNECTOR_LOCK_FAILURE",
	EV_COMMUNICATION_ERROR: "EV_COMMUNICATION_ERROR",
	GROUND_FAILURE: "GROUND_FAILURE",
	HIGH_TEMPERATURE: "HIGH_TEMPERATURE",
	INTERNAL_ERROR: "INTERNAL_ERROR",
	LOCAL_LIST_CONFLICT: "LOCAL_LIST_CONFLICT",
	NO_ERROR: "NO_ERROR",
	OTHER_ERROR: "OTHER_ERROR",
	OVER_CURRENT_ERROR: "OVER_CURRENT_ERROR",
	POWER_METER_FAILURE: "POWER_METER_FAILURE",
	POWER_SWITCH_FAILURE: "POWER_SWITCH_FAILURE",
	READER_FAILURE: "READER_FAILURE",
	RESET_FAILURE: "RESET_FAILURE",
	UNDER_VOLTAGE: "UNDER_VOLTAGE",
	OVER_VOLTAGE: "OVER_VOLTAGE",
	WEAK_SIGNAL: "WEAK_SIGNAL",
};

export const E_BadgeImportMode = {
	FULL: "FULL",
	ADD_ONLY: "ADD_ONLY"
}

/**
 * Sticker version enum
 * ---
 * Layout of the charging instructions sticker. V1 is the original bilingual CZ/EN leaflet and ignores the
 * language selection.
 * @enum string
 * @readonly
 */
export const E_StickerVersion = {
	V1: "V1",
	V2: "V2"
}

export const E_UserBillingDetailsMode = {
	NAME: "NAME",
	ADDRESS: "ADDRESS",
	BILLING_DETAILS: "BILLING_DETAILS"
}

/**
 * Export CSOB bulk payment order format enum
 * ---
 * @readonly
 * @enum string
 */
export const E_ExportCSOBBulkPaymentOrder_Format = {
	DOMESTIC: "DOMESTIC",
	FOREIGN: "FOREIGN",
};

/**
 * Export CSOB bulk payment order model
 * ---
 * @type {{
 *  bankAccountID: number,
 *  format: string,
 * }}
 */
export const model__exportCSOBBulkPaymentOrder = {
	format: E_ExportCSOBBulkPaymentOrder_Format.DOMESTIC,
	bankAccountID: null,
};

/**
 * Partner billing summary export model
 * ---
 * The currency is mandatory - amounts of different currencies cannot be summed up.
 * The period is optional and only limits the total billed amount.
 * @type {{
 *  currency: string,
 *  from: Date,
 *  to: Date,
 * }}
 */
export const model__partnerBillingSummaryExport = {
	currency: null,
	from: null,
	to: null,
};

export const E_PaymentState = {
	PENDING: "PENDING",
	RETRYING: "RETRYING",
	FAILED: "FAILED",
	VOIDED: "VOIDED",
	REFUNDED: "REFUNDED",
	SETTLED: "SETTLED",
};

/**
 * CouponPurchaseBracket model
 * ---
 * @type {{
 * 	id?: number,
 * 	createdOn?: Date,
 * 	priceWithoutVat?: number,
 * 	priceWithVat?: number
 * }}
 */
export const model__couponPurchaseBracket = {
	id: undefined,
	createdOn: undefined,
	priceWithoutVat: 0,
	priceWithVat: 0,
};

/**
 * CouponPurchaseConfiguration model
 * ---
 * @type {{
 * 	id?: number,
 * 	createdOn?: Date,
 * 	enabled?: boolean,
 * 	currency: E_Currency,
 * 	description?: [],
 * 	taxPercent?: number,
 * 	options?: model__couponPurchaseBracket[],
 * 	orderSeries?: model_sequence,
 * 	invoiceIssuer?: model_partner,
 * 	electricityBuyer?: model_partner
 * }}
 */
export const model__couponPurchaseConfiguration = {
	id: undefined,
	createdOn: undefined,
	enabled: true,
	currency: E_Currency.CZK,
	description: [],
	taxPercent: 0,
	options: [],
	orderSeries: null,
	invoiceIssuer: null,
	electricityBuyer: null,
};

/**
 * Authorization result enum
 * ---
 * @enum string
 * @readonly
 */
export const E_TokenEvent_AuthorizationResult = {
	AUTHORIZED: "AUTHORIZED",
	UNAUTHORIZED: "UNAUTHORIZED",
};

/**
 * Token event item service type enum
 * ---
 * @enum string
 * @readonly
 */
export const E_TokenEventItem_ServiceType = {
	MIRROR: "MIRROR",
	LOCAL: "LOCAL",
	ROAMING: "ROAMING",
	OCPI: "OCPI",
	SYGIC: "SYGIC",
	HUBJECT: "HUBJECT",
};

/**
 * Token type
 * ---
 * @type {{HUBJECT, OTHER, EMAID, RFID, OCPI}}
 * @enum string
 * @readonly
 */
export const E_TokenType = {
	RFID: "RFID",
	HUBJECT: "HUBJECT",
	EMAID: "EMAID",
	OCPI: "OCPI",
	OTHER: "OTHER",
}

/**
 * Token event item result enum
 * ---
 * @enum string
 * @readonly
 */
export const E_TokenEventItem_Result = {
	AUTHORIZED: "AUTHORIZED",
	UNAUTHORIZED: "UNAUTHORIZED",
};

/**
 * Token event item rejection reason enum
 * ---
 * @enum string
 * @readonly
 */
export const E_TokenEventItem_RejectionReason = {
	TOKEN_NOT_FOUND: "TOKEN_NOT_FOUND",
	TOKEN_DISABLED: "TOKEN_DISABLED",
	USER_DISABLED: "USER_DISABLED",
	USER_NOT_FOUND: "USER_NOT_FOUND",
	PARTNER_RESTRICTION: "PARTNER_RESTRICTION",
	CONNECTOR_TYPE_RESTRICTION: "CONNECTOR_TYPE_RESTRICTION",
	PAYMENT_REQUIRED: "PAYMENT_REQUIRED",
	CONNECTOR_NOT_FOUND: "CONNECTOR_NOT_FOUND",
	INTERNAL_ERROR: "INTERNAL_ERROR",
	TOKEN_UNAUTHORIZED: "TOKEN_UNAUTHORIZED",
	NETWORK_ERROR: "NETWORK_ERROR",
	CLIENT_DISABLED: "CLIENT_DISABLED",
	NOT_SUPPORTED: "NOT_SUPPORTED",
	COMMISSIONING_IN_PROGRESS: "COMMISSIONING_IN_PROGRESS",
	UNIT_NOT_FOUND: "UNIT_NOT_FOUND",
	CONNECTOR_NOT_AVAILABLE: "CONNECTOR_NOT_AVAILABLE",
};

/**
 * Token event item model
 * ---
 * @type {{
 * 	id?: number,
 * 	createdOn?: Date,
 * 	connector?: model_connector,
 * 	location?: model_location,
 * 	serviceType?: E_TokenEventItem_ServiceType,
 * 	result?: E_TokenEventItem_Result,
 * 	rejectionReason?: E_TokenEventItem_RejectionReason,
 * 	message?: string,
 * 	token?: model_token,
 * 	time?: Date
 * }}
 */
export const model__TokenEventItem = {
	id: undefined,
	createdOn: undefined,
	connector: null,
	location: null,
	serviceType: E_TokenEventItem_ServiceType.MIRROR,
	result: E_TokenEventItem_Result.AUTHORIZED,
	rejectionReason: E_TokenEventItem_RejectionReason.TOKEN_NOT_FOUND,
	message: '',
	token: null,
	time: undefined,
};

/**
 * Token event model
 * ---
 * @type {{
 * 	id?: number,
 * 	createdOn?: Date,
 * 	tokenID?: number,
 * 	token?: string,
 * 	connectorID?: number,
 * 	chargePointIdentity?: string,
 * 	location?: model_location,
 * 	authorizationResult?: E_TokenEvent_AuthorizationResult,
 * 	items?: model__TokenEventItem[]
 * }}
 */
export const model__TokenEvent = {
	id: undefined,
	createdOn: undefined,
	tokenID: 0,
	token: '',
	connectorID: 0,
	chargePointIdentity: '',
	location: null,
	authorizationResult: E_TokenEvent_AuthorizationResult.AUTHORIZED,
	items: [],
};

/**
 * Auto export type enum
 * ---
 * @enum string
 * @readonly
 */
export const E_AutoExport_Type = {
	PERIODIC: "PERIODIC",
	ONE_TIME: "ONE_TIME",
};

/**
 * Auto export period enum
 * ---
 * @enum string
 * @readonly
 */
export const E_AutoExport_Period = {
	DAY: "DAY",
	WEEK: "WEEK",
	MONTH: "MONTH",
	YEAR: "YEAR"
};

/**
 * Auto export configuration model
 * ---
 * @type {{
 *  id: number,
 *  createdOn: Date,
 *  enabled: boolean,
 *  name: string,
 *  exportProfileSave: model__exportProfile,
 *  entityType: E_ExportEntity,
 *  entityID: number,
 *  author: model_user,
 *  emails: string,
 *  locale: string,
 *  timezone: string,
 *  filters: string,
 *  filterConfiguration: string,
 *  type: E_AutoExport_Type,
 *  startTime: Date,
 *  lastTriggerTime: Date,
 *  nextTriggerTime: Date,
 *  period: E_AutoExport_Period,
 * }}
 */
export const model__autoExportConfiguration = {
	id: undefined,
	createdOn: undefined,
	enabled: true,
	name: "",
	exportProfileSave: null,
	entityType: null,
	entityID: undefined,
	author: undefined,
	emails: "",
	locale: "cs",
	timezone: "Europe/Prague",
	filterConfiguration: "",
	filters: undefined,
	type: E_AutoExport_Type.PERIODIC,
	startTime: undefined,
	lastTriggerTime: undefined,
	nextTriggerTime: undefined,
	period: undefined,
};

/**
 * User group model
 * ---
 * @type {{
 *  id: number,
 *  createdOn: Date,
 *  name: string,
 *  description: string,
 *  partner: model_partner
 * }}
 */
export const model_userGroup = {
	id: undefined,
	createdOn: undefined,
	name: "",
	description: "",
	partner: null,
};

/**
 *
 * @type {{
 *  id: number,
 *  createdOn: Date,
 *  productName: [],
 *  amount: model__cost,
 *  unitAmount: model__cost,
 *  taxPercent: number,
 *  quantity: number,
 *  unitSuffix: string,
 *  productID: string
 * }}
 */
export const model__invoiceDataItem = {
	id: undefined,
	createdOn: undefined,
	productName: [],
	amount: model__cost,
	unitAmount: model__cost,
	taxPercent: 0,
	quantity: 0,
	unitSuffix: "",
	productID: "",
};

/**
 * Facility category
 * ---
 * @enum string
 * @readonly
 */
export const E_FacilityCategory = {
	ENTERTAINMENT: "ENTERTAINMENT",
	SHOPPING: "SHOPPING",
	ACCOMMODATION: "ACCOMMODATION",
	NATURE: "NATURE",
	REFRESHMENTS: "REFRESHMENTS",
	PAYMENT: "PAYMENT",
	LOCATION: "LOCATION",
	TRANSPORTATION: "TRANSPORTATION",
	OTHER: "OTHER",
};

/**
 * Facility model
 * ---
 * @type {{
 *   id: number,
 *   createdOn: Date,
 *   name: [],
 *   description: [],
 *   category: E_FacilityCategory,
 *   deletable: boolean,
 * }}
 */
export const model__facility = {
	id: undefined,
	createdOn: undefined,
	name: [],
	description: [],
	category: null,
	deletable: true,
};

/**
 * Approve partner invoice model
 * ---
 * @type {{
 *   sendEmail: boolean,
 *   createPaymentEntry: boolean
 * }}
 */
export const model__approvePartnerInvoice = {
	sendEmail: true,
	createPaymentEntry: true,
};

/**
 * Permissions template template key enum
 * ---
 * @enum string
 * @readonly
 */
export const E_PermissionsTemplateTemplateKey = {
	FULL_ADMIN: "FULL_ADMIN",
	PARTNER_ADMIN: "PARTNER_ADMIN",
	PARTNER_READ_ONLY: "PARTNER_READ_ONLY",
	CUSTOM: "CUSTOM",
};

/**
 * Permissions template model
 * ---
 * @type {{
 * 	id?: number,
 *	createdOn?: Date,
 *	templateKey?: E_PermissionsTemplateTemplateKey,
 *	customName?: string,
 *	description?: string,
 *	partner?: model__partnerName,
 *	permissions?: {},
 *	editable?: boolean,
 * }}
 */
export const model__permissionsTemplate = {
	id: undefined,
	createdOn: undefined,
	templateKey: E_PermissionsTemplateTemplateKey.FULL_ADMIN,
	customName: '',
	description: '',
	partner: null,
	permissions: {},
	editable: true,
};

/**
 * Connector ID Detection Strategy enum
 * ---
 * @enum string
 * @readonly
 */
export const E_ConnectorIDDetectionStrategy = {
	PHYSICAL_REFERENCE: "PHYSICAL_REFERENCE",
	LAST_EVSE_ID_PART: "LAST_EVSE_ID_PART",
	CONNECTOR_ID: "CONNECTOR_ID",
};

/**
 * Partner ID Detection Strategy enum
 * ---
 * @enum string
 * @readonly
 */
export const E_PartnerIDDetectionStrategy = {
	CLIENT_PARTNER: "CLIENT_PARTNER",
	LOCATION_NAME_PREFIX_MAP: "LOCATION_NAME_PREFIX_MAP",
	DIRECTIONS_CONTENT_MAP: "DIRECTIONS_CONTENT_MAP",
};

/**
 * Location Visibility Strategy enum
 * ---
 * @enum string
 * @readonly
 */
export const E_LocationVisibilityStrategy = {
	PUBLISH_FALSE_PRIVATE: "PUBLISH_FALSE_PRIVATE",
	PUBLISH_FALSE_HIDDEN: "PUBLISH_FALSE_HIDDEN",
};

/**
 * Client model
 * ---
 * @type {{
 * 	id?: number,
 *	createdOn?: Date,
 *	name?: string,
 *	status?: E_ClientStatus,
 *	versionsUrl?: string,
 *	roles?: model__credentialsRole[],
 *	encodeToken?: boolean,
 *	tokenA?: string,
 *	tokenB?: string,
 *	tokenC?: string,
 *	version?: E_VersionNumber,
 *	endpointUrls?: Object,
 *	partner?: model__partnerName,
 *	readOnlyMode?: boolean,
 *	additionalHeaders?: string,
 *	overrideBaseUrl?: string,
 *	connectorIDDetectionStrategy?: E_ConnectorIDDetectionStrategy,
 *	partnerIDDetectionStrategy?: E_PartnerIDDetectionStrategy,
 *	partnerIDMapping?: string,
 *	locationVisibilityStrategy?: E_LocationVisibilityStrategy,
 *	privateBadgeTypeID?: number,
 * }}
 */
export const model__OCPIClient = {
	id: undefined,
	name: '',
	encodeToken: false,
	readOnlyMode: false,
	additionalHeaders: '',
	connectorIDDetectionStrategy: E_ConnectorIDDetectionStrategy.CONNECTOR_ID,
	partnerIDDetectionStrategy: E_PartnerIDDetectionStrategy.CLIENT_PARTNER,
	locationVisibilityStrategy: E_LocationVisibilityStrategy.PUBLISH_FALSE_HIDDEN,
	partnerIDMapping: '',
	privateBadgeTypeID: '',
};

/**
 * Register Ocpi Client Params model
 * ---
 * @type {{
 * 	name?: string,
 *	versionsUrl: string,
 *	token: string,
 *	encodeToken?: boolean,
 *	partner: model__partnerName,
 *	readOnlyMode?: boolean,
 *	additionalHeaders?: string,
 *	overrideBaseUrl?: string,
 * }}
 */
export const model__registerOcpiClientParams = {
	name: '',
	versionsUrl: '',
	token: '',
	encodeToken: false,
	partner: null,
	readOnlyMode: false,
	additionalHeaders: '',
	overrideBaseUrl: '',
};
